import { useLayoutEffect, useContext } from "react";
import { AuthContext } from "contexts/AuthContext";
import { loadScript, unloadScripts } from "utils/scriptLoader";

const TerraCastilla = () => {
  const authContext = useContext(AuthContext);

  useLayoutEffect(() => {
    // Set container style to display block
    const container = document.getElementById("container");
    if (getComputedStyle(container).getPropertyValue("display") === "none") {
      container.style.setProperty("display", "block");
    }

    // 1. First, load pano2vr_player.js
    if (authContext.user) {
      loadScript("PanoScript", "pano2vr_player.js")
        .then(() => {
          const { uid } = authContext.user;
          // 2. then, load skin.js
          return loadScript("SkinJS", `skin.js?comprador=${uid || "NA"}`);
        })
        .then(() => {
          // 3. load panoramas.js
          return loadScript("PanoramasJS", "panoramas.js");
        })
        .then(() => {
          // 4. Finally, load perspektiva360.js
          return loadScript(
            "Perspektiva360",
            "perspektiva360/perspektiva360.js"
          );
        })
        .then(() => {
          console.log("ALL SCRIPTS LOADED!");
        })
        .catch((err) => {
          console.error(err);
          alert(err);
        });

      // asynchronously, load analytics.js
      loadScript("Gtag", "perspektiva360/analytics.js").catch((err) => {
        console.error(err);
        alert(err);
      });
    }

    /* A cleanup function that unload scripts and set container style to display none. */
    return () => {
      unloadScripts();
      document.getElementById("container").style.setProperty("display", "none");
    };
  }, [authContext.user]);
};

export default TerraCastilla;
